import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import PatientDashBoard from './PatientDashBoard';
import PatientDashBoardTable from './PatientDashBoardTable';
import ErrorBoundary from '../../ErrorBoundary';
import DashBoardMedAdherence from './DashBoardMedAdherence';
import { ToastContainer, toast } from 'react-toastify';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { tokenVerification } from "./Utils";
import PatientBreachedRuleDashBoard from './PatientBreachedRuleDashBoard';
import PatientJournalStatus from './PatientJournalStatus';
import DashBoardJournalStatus from './DashBoardJournalStatus';



class PatientVitalTabSettings extends Component {
    constructor() {
        super();
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const pastTenDays = new Date();
        pastTenDays.setDate(pastTenDays.getDate() - 10);
        const today = new Date();
        this.state = {
            showHomeEnityName: localStorage.getItem("homeEntityName"),
            projectId: null,
            hideBotStore: false,
            patientAdmissionHeading: '',
            fromDate: localStorage.getItem("startDate") ? new Date(localStorage.getItem("startDate")) : pastTenDays,
            toDate: localStorage.getItem("endDate") ? new Date(localStorage.getItem("endDate")) : today,
            // fromDate: pastTenDays,
            // toDate: today,
            riskLevel: localStorage.getItem("riskLevel").toLowerCase().replace(/_/g, " ").replace(/\b\w/g, function (char) { return char.toUpperCase(); }),
            selectedHealthSystemId: "",
            selectedHospitalId: "",
            selectedServiceLineId: "",
            breachedRuleSetNames : ""
        }
        this.state.selectedHealthSystemId = localStorage.getItem("healthSystemId");
        this.state.selectedHospitalId = localStorage.getItem("hospitalId");
        this.state.selectedServiceLineId = localStorage.getItem("serviceLineId");
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
        window.admissionsNavBarController = this;
    }

    componentDidMount() {

        if (!this.tabClickHandlerDefined) {
            this.tabClickHandlerDefined = true;
            $("#dashboard-graph,#dashboard-table,#dashboard-med-adherence")
                .on("click", function () {
                    $("#dashboard-graph,#dashboard-table,#dashboard-med-adherence")
                        .removeClass('active');
                    localStorage.setItem("dashboard-nav-bar-selection", $(this)[0].id);
                    $(this).addClass('active')
                });
        }
        this.markActiveTab();

        let enteredLastNDays = localStorage.getItem("selectedNdays");
        let fromDate = localStorage.getItem("startingDate");
        let toDate = localStorage.getItem("endingDate");
        if (enteredLastNDays) {
            localStorage.setItem("enteredLastNDays", enteredLastNDays);
            localStorage.setItem("riskStatusStartDate", fromDate);
            localStorage.setItem("riskStatusEndDate", toDate);

        }
        this.fetchBreachedRules();
        this.intervalId = setInterval(this.fetchBreachedRules, 99);

    }
    componentWillUnmount() {
        localStorage.removeItem("selectedNdays");
        localStorage.removeItem("startingDate");
        localStorage.removeItem("endingDate");
        clearInterval(this.intervalId);

    }

    fetchBreachedRules = () => {
        // Fetch the latest value from localStorage
        const latestValue = localStorage.getItem("breachedRuleSetNames");
        this.setState({ breachedRuleSetNames: latestValue });
      };

    markActiveTab() {
        $("#dashboard-graph,#dashboard-table, #dashboard-med-adherence").removeClass('active');
        var defaultSelection = false;
        var savedNavBarSelection = localStorage.getItem("dashboard-nav-bar-selection");
        var currentPath = window.location.href;
        if (currentPath.includes('/projectmgmt/reports/patient-dashboard') || currentPath.includes('/projectmgmt/reports/patient-dashboard/')) {
            defaultSelection = "dashboard-graph";
        } else if (currentPath.includes('/projectmgmt/reports/dashboard-table') || currentPath.includes('/projectmgmt/reports/dashboard-table/')) {
            defaultSelection = "dashboard-table";
        } else if (currentPath.includes('/projectmgmt/reports/dashboard-med-adherence') || currentPath.includes('/projectmgmt/reports/dashboard-med-adherence/')) {
            defaultSelection = "dashboard-med-adherence";
        }
        if (defaultSelection !== false) {
            $("#patientDashBoardMenu #" + defaultSelection).addClass('active');
            localStorage.setItem("dashboard-nav-bar-selection", defaultSelection);
        } else {
            if (savedNavBarSelection) {
                $("#patientDashBoardMenu #" + savedNavBarSelection).addClass('active');
            }

        }
    }

    fetchRiskLevel = () => {
        var thisController = this;
        var userRole = thisController.userDetails["userRole"];
        if (userRole == "HEALTHSYSTEM_ADMIN") {
            thisController.state.selectedHealthSystemId =
                thisController.userDetails["healthSystemId"];
        } else if (
            userRole == "HOSPITAL_ADMIN" ||
            userRole == "SERVICELINE_ADMIN" ||
            userRole == "PHYSICIAN"
        ) {
            thisController.state.selectedHealthSystemId =
                thisController.userDetails["healthSystemId"];
            thisController.state.selectedHospitalId =
                thisController.userDetails["hospitalId"];
        } else if (
            userRole == "SERVICELINE_ADMIN" ||
            userRole == "PHYSICIAN"
        ) {
            thisController.state.selectedHealthSystemId =
                thisController.userDetails["healthSystemId"];
            thisController.state.selectedHospitalId =
                thisController.userDetails["hospitalId"];
            thisController.state.selectedServiceLineId = thisController.userDetails["serviceLineId"];
        }
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/fetch-risk-based-admissions",

            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                healthSystemId: thisController.state.selectedHealthSystemId,
                hospitalId: thisController.state.selectedHospitalId,
                serviceLineId: thisController.state.selectedServiceLineId,
                startDate: thisController.state.fromDate,
                endDate: thisController.state.toDate
            },
            success: function (res) {
                if (res.success === true) {
                    var userRole = thisController.userDetails["userRole"];
                    var userId = thisController.userDetails["userId"];
                    var patientAddmissionId = localStorage.getItem("patientAdmissionId");
                    thisController.state.isLoading = false;
                    thisController.setState(thisController.state);
                    var admissionData = res.result;
                    var numberOfAdmission = admissionData.length;
                    for (var i = 0; i < numberOfAdmission; i++) {
                        if (patientAddmissionId == admissionData[i].id) {
                            thisController.state.riskLevel = admissionData[i].patientRisk.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, function (char) { return char.toUpperCase(); });

                        }
                    }
                    thisController.setState(thisController.state);
                } else {
                    thisController.notifyFailedLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ": " + xhr.statusText;
                if (xhr.status == 401) {
                    tokenVerification();
                }
            },
        });
    };

    handleFromDateChange = (date) => {
        const { toDate } = this.state;
        const fromDate = new Date(date);
        fromDate.setHours(0, 0, 0, 0);

        if (fromDate <= toDate) {
            // localStorage.setItem("startDate", date);
            // localStorage.setItem("endDate", this.state.toDate);
            localStorage.setItem("entryStartDate", fromDate);
            this.setState({
                fromDate: fromDate
            });
        } else {
            this.notifyImproperDateSelection("from");
        }
    };

    // handleToDateChange = (date) => {
    //     const { fromDate } = this.state;
    //     const today = new Date();
    //     const toDate = new Date(date);


    //     if (date >= fromDate && (date <= today)) {
    //         // localStorage.setItem("startDate", this.state.fromDate);
    //         // localStorage.setItem("endDate", date);
    //         localStorage.setItem("entryEndDate", toDate);
    //         this.setState({
    //             toDate: toDate
    //         }, () => {
    //             this.fetchRiskLevel();
    //         })
    //     } else if (date < fromDate) {
    //         this.notifyImproperDateSelection("to");
    //     } else if (date > today) {
    //         this.notifyImproperToDateSelection();
    //     }
    // };

    handleToDateChange = (date) => {
        const { fromDate } = this.state;
        const today = new Date();
        const toDate = new Date(date);

        // Set `toDate` time to the end of the day (23:59:59)
        toDate.setHours(23, 59, 59, 999);
        today.setHours(23, 59, 59, 999);

        if (toDate >= fromDate && toDate <= today) {
            localStorage.setItem("entryEndDate", toDate);
            this.setState({
                toDate: toDate
            })
        } else if (toDate < fromDate) {
            this.notifyImproperDateSelection("to");
        }else if (toDate > today) {
            this.notifyImproperToDateSelection();
        }

    };



    notifyFailedLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red",
        });
    }


    notifyImproperDateSelection(message) {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                />
                &nbsp;&nbsp;{message === "from" ? "From date should be less than To Date." : "To date should be greater than From Date."}
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyImproperToDateSelection() {

        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                />
                &nbsp;&nbsp; To date cannot be greater than today's date.
            </b>,
            {
                position: "top-center",
            }
        );
    }
    backToRiskBoard = () => {
        // localStorage.setItem("startDate", this.state.fromDate);
        // localStorage.setItem("endDate", this.state.toDate);
        this.props.history.push({
            pathname: "/projectmgmt/reports"
        })
    }
    handleClick = () => {
        localStorage.setItem("atRisk", true);
    }
    render() {
        this.markActiveTab();
        return (
            <ErrorBoundary>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/DashBoardGraph.css" />

                        <div className="container-fluid" >
                            <div>
                                <div className="row">

                                    <img
                                        className="img-responsive"
                                        src="./assets/images/arrow.svg"
                                        style={{ marginLeft: "5px", cursor: "pointer" }}
                                        onClick={this.backToRiskBoard}
                                    />

                                    {/* <h4 style={{ marginLeft: "3px", marginTop: "6px" }}> {localStorage.getItem("patientName")}'s Vital </h4> */}

                                    <div style={{ marginLeft: "15vw", marginTop: "-3vh", width: "45vw", display: "flex" }}>
                                        <div style={{ width: "15vw" }}>
                                            <label style={{ marginRight: "12px", marginTop: "22px" }}>From</label>
                                            <DatePicker
                                                id="fromDate"
                                                selected={this.state.fromDate}
                                                onChange={this.handleFromDateChange}
                                                autoOk={true}
                                                placeholderText="From Date"
                                                className="form-control"
                                                dateFormat="MM/dd/yyyy"
                                            />
                                        </div>
                                        <div style={{ width: "15vw", marginLeft: "5vw" }}>
                                            <label style={{ marginRight: "12px", marginTop: "22px" }}>To</label>
                                            <DatePicker
                                                selected={this.state.toDate}
                                                id="toDate"
                                                onChange={this.handleToDateChange}
                                                autoOk={true}
                                                placeholderText="To Date"
                                                className="form-control"
                                                dateFormat="MM/dd/yyyy"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Patient Information Section */}
                                <div className="patient-info-container">
                                    <div className="patient-info-box">
                                        <strong>Patient Name</strong>
                                        <p>{localStorage.getItem("patientName")}</p>
                                    </div>
                                    <div className="patient-info-box">
                                        <strong>Triggered Rules</strong>
                                        <p>{this.state.breachedRuleSetNames}</p>
                                    </div>
                                    {/* <div className="patient-info-box">
                        <strong>Patient Risk Level</strong>
                        <p>{localStorage.getItem("riskLevel")}</p>
                    </div> */}
                                    <div className="patient-info-box">
                                        <strong>Treatment Name</strong>
                                        <p>{localStorage.getItem("procedureName")}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-class">

                                <ul className="nav nav-tabs border-bottom navCluster" id="patientDashBoardMenu">
                                    <Link className="nav-item" data-toggle="tab" onClick={this.handleClick}
                                        to="/projectmgmt/reports/patient-dashboard" style={{ textDecoration: 'none' }}  >
                                        <li className="nav-link" id="dashboard-graph" style={{ marginRight: '15px' }}>
                                            Dashboard
                                        </li></Link>

                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/reports/dashboard-table" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="dashboard-table" style={{ marginRight: '15px' }}>
                                            Treatment Journals
                                        </li></Link>
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/reports/dashboard-med-adherence" style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="dashboard-med-adherence" style={{ marginRight: '15px' }}>
                                            Medication Adherence
                                        </li></Link>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/projectmgmt/reports/patient-dashboard"
                            render={(props) => (
                                <PatientBreachedRuleDashBoard
                                    {...props}
                                    fromDate={this.state.fromDate} // Replace fromDate with your actual from date value
                                    toDate={this.state.toDate}     // Replace toDate with your actual to date value
                                />)}
                        />

                        {/* <Route path="/projectmgmt/reports/dashboard-table" 
                        render={(props) => (
                            <PatientDashBoardTable
                              {...props}
                              fromDate={this.state.fromDate} 
                              toDate={this.state.toDate}     
                            />)}
                            /> */}
                        <Route path="/projectmgmt/reports/dashboard-table"
                            render={(props) => (
                                <PatientJournalStatus
                                    {...props}
                                    fromDate={this.state.fromDate}
                                    toDate={this.state.toDate}
                                />)}
                        />
                        {/* <Route path="/projectmgmt/reports/dashboard-journal-status" component={DashBoardJournalStatus} ></Route> */}
                        <Route path="/projectmgmt/reports/dashboard-journal-status"
                            render={(props) => (
                                <DashBoardJournalStatus
                                    {...props}
                                    fromDate={this.state.fromDate}
                                    toDate={this.state.toDate}
                                />)}
                        />
                        <Route path="/projectmgmt/reports/dashboard-med-adherence"
                            render={(props) => (
                                <DashBoardMedAdherence
                                    {...props}
                                    fromDate={this.state.fromDate}
                                    toDate={this.state.toDate}
                                />)}
                        />
                    </Switch>
                    <ToastContainer className="Toast-at-center" />
                </div>
            </ErrorBoundary>
        );
    }
}
export default PatientVitalTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientVitalTabSettings.js